<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-18 11:34:51
-->
<template>
  <!-- 育苗 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div class="type-activite">损失数据查询</div>
      </div>
      <div class="page-list">
        <!-- 搜索栏 -->
        <div class="page-search-content" ref="searchBox">
          <div class="page-big-box">
            <div class="page-search-item">
              <label>养殖场&nbsp;:</label>
              <el-select v-model="params.params.baseId" filterable placeholder="请选择养殖场">
                <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>养殖区域&nbsp;:</label>
              <el-select v-model="params.params.breedingAreaId" filterable placeholder="请选择养殖区域">
                <el-option label="全部养殖区域" value=""></el-option>
                <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>养殖单元&nbsp;:</label>
              <el-select v-model="params.params.boxId" filterable placeholder="请选择养殖单元">
                <el-option label="全部养殖单元" value=""></el-option>
                <el-option v-for="item in boxList" :key="item.id" :label="item.boxCode" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>养殖造次&nbsp;:</label>
              <el-select v-model="params.params.periodId" filterable placeholder="请选择养殖造次">
                <el-option label="全部养殖造次" value=""></el-option>
                <el-option v-for="item in periodList" :key="item.id" :label="item.year + item.makeValue" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>养殖品类&nbsp;:</label>
              <el-select v-model="params.params.breedingCategoryId" filterable placeholder="请选择养殖品类">
                <el-option label="全部养殖品类" value=""></el-option>
                <el-option v-for="item in breedTypeList" :key="item.breedTypeId" :label="item.breedTypeName"
                  :value="item.breedTypeId">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>养殖品种&nbsp;:</label>
              <el-select v-model="params.params.breedNameId" filterable placeholder="请选择养殖品种">
                <el-option label="全部养殖品种" value=""></el-option>
                <el-option v-for="item in breedList" :key="item.id" :label="item.breedName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>损失原因&nbsp;:</label>
              <el-select v-model="params.params.reason" filterable placeholder="请选择损失原因">
                <el-option label="全部损失原因" value=""></el-option>
                <el-option v-for="item in lossCauseList" :key="item.id" :label="item.value" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>损失类型&nbsp;:</label>
              <el-select v-model="params.params.storageWeight" filterable placeholder="请选择损失类型">
                <el-option label="全部损失类型" value=""></el-option>
                <el-option v-for="item in lossTypeList" :key="item.id" :label="item.value" :value="item.id">
                </el-option>
              </el-select>
            </div>

            <!-- 选择日期年月日 -->
            <div class="page-search-date">
              <div class="page-search-item date-selection-box">
                <span @click="params.params.type = 'Y'" :class="[params.params.type == 'Y' ? 'active-date' : '']">年</span>
                <span @click="params.params.type = 'M'" :class="[params.params.type == 'M' ? 'active-date' : '']">月</span>
                <span @click="params.params.type = 'D'" :class="[params.params.type == 'D' ? 'active-date' : '']">日</span>
              </div>
              <div class="page-search-item" v-show="params.params.type === 'Y'">
                <label>年份&nbsp;:</label>
                <el-date-picker value-format="yyyy" format="yyyy" v-model="params.params.year" type="year"
                  placeholder="请选择年份">
                </el-date-picker>
              </div>
              <div class="page-search-item" v-show="params.params.type === 'M'">
                <label>月份区间&nbsp;:</label>
                <el-date-picker v-model="monthRange" format="yyyy-MM" value-format="yyyy-MM" @change="monthChange"
                  type="monthrange" range-separator="~" start-placeholder="开始月份" end-placeholder="结束月份">
                  >
                </el-date-picker>
              </div>
              <div class="page-search-item" v-show="params.params.type === 'D'">
                <label>日期区间&nbsp;:</label>
                <el-date-picker v-model="dateRange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="dateChange"
                  type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="page-search-btn">
            <div class="search-btn" @click="search">查询</div>
            <div class="reset-btn" @click="reset">重置</div>
            <div class="search-close-btn">
              <div @click="PageSearchClose" v-if="PageDisplay">
                <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
              </div>
              <div @click="PageSearchOn" v-else>
                <span>展开</span><i class="iconfont icon-List-Collapse"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <div class="page-list-content">
          <!-- 列表 -->
          <div class="page-list-title">
            <div><i class="title-icon"></i>损失数据查询</div>
            <div>单位: {{ orgName }}</div>
            <!-- 年报表 -->
            <div v-if="params.params.type == 'Y'">年份 : {{ showYear }}年</div>
            <!-- 月报表 -->
            <div v-if="params.params.type == 'M'">
              月份 :
              {{ showStartDate }}-{{ showEndDate }}
            </div>
            <!-- 日报表 -->
            <div v-if="params.params.type == 'D'">
              日期 :
              {{ showStartDate }}-{{ showEndDate }}
            </div>
            <div class="page-list-btns">
              <el-dropdown style="margin-right: 20px;" @command="setFixedColumn">
                <span class="el-dropdown-link">
                  冻结列<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="y">冻结至"{{
                    fixedColumn.label
                  }}"列</el-dropdown-item>
                  <el-dropdown-item command="n">取消冻结</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span class="switch-table" @click="download">模板下载</span>
              <FileUpload class="switch-table" :url="fileupload">导入报表</FileUpload>
              <span @click="exportTable">
                <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
              </span>
            </div>
          </div>
          <!-- 表格 -->
          <el-table :data="lossDataList" row-key="id" :max-height="tableHeight" border style="width: 100%"
            :row-class-name="tableRowClassName" @header-click="handleClick">
            <el-table-column :fixed="fixedColumnList[0].fixed"
              :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''" prop="baseName"
              label="养殖场"></el-table-column>
            <el-table-column :fixed="fixedColumnList[1].fixed"
              :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''" prop="lossTime" label="损失日期">
              <template slot-scope="scope">
                {{ scope.row.lossTime ? scope.row.lossTime.slice(0, 16) : "" }}
              </template>
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[2].fixed"
              :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''" prop="breedingArea" label="养殖区域">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[3].fixed"
              :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''" prop="breedingPond" label="养殖单元">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[4].fixed"
              :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''" prop="farmingTimes" label="养殖造次">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[5].fixed"
              :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''" prop="typeCategory" label="养殖品类">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[6].fixed"
              :class-name="fixedColumnList[6].selected ? 'cellSelected' : ''" prop="breedName" label="养殖品种">
            </el-table-column>
            <el-table-column prop="lossNumber" label="损失数量">
            </el-table-column>
            <el-table-column prop="lossSpec" label="损失规格">
            </el-table-column>
            <el-table-column prop="totalWeight" label="损失重量">
            </el-table-column>
            <el-table-column prop="storageWeight" label="预估存塘重量">
            </el-table-column>
            <el-table-column prop="typeLoss" label="损失类型">
            </el-table-column>
            <el-table-column prop="reasonName" label="预估原因">
            </el-table-column>
            <el-table-column prop="remark" label="备注"> </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="uyu-pagination">
            <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
              :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="pageNo" :pageSize.sync="pageSize"
              :totalCount="totalCount">
            </MyPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyPagination from "@/components/pc/my-pagination.vue";
import FileUpload from "@/components/pc/file-upload.vue";
import Page from "@/utils/methods/page";
import {
  getListByPages,
  downloadTemplate,
  exportTable,
  importTable,
  getBaseListsByUser,
  queryBaseGroupList,
  listDataPermissionBoxData,
  getBatchList,
  getOrgInfoByOrgId,
  getBreedList,
  getBreedTypeList,
  getDictionaryByType,
} from "./ym-loss-service";
export default {
  name: "ym-loss",
  data() {
    return {
      monthRange: [],
      dateRange: [],
      PageDisplay: true,
      showYear: "", // 显示的年份
      showStartDate: "", // 显示的开始日期
      showEndDate: "", // 显示的结束日期
      lossCauseList: [], // 预估原因列表
      lossDataList: [], // 损失数据列表
      boxList: [],
      baseList: [],
      groupList: [],
      periodList: [],
      breedList: [],
      breedTypeList: [],
      pagelist: {},
      pageNo: 1,
      pageSize: 13,
      totalCount: 0,
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "lossTime",
          fixed: false,
          selected: false
        },
        {
          prop: "breedingArea",
          fixed: false,
          selected: false
        },
        {
          prop: "breedingPond",
          fixed: false,
          selected: false
        },
        {
          prop: "farmingTimes",
          fixed: false,
          selected: false
        },
        {
          prop: "typeCategory",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      params: {
        currPage: 1,
        pageSize: 13,
        orderBy: "desc",
        orderByName: "lossTime",
        params: {
          orgId: "",
          baseId: "",
          boxId: "",
          periodId: "",
          breedingAreaId: "", // 养殖区域id
          breedingCategoryId: "", // 养殖品类id
          breedNameId: "", // 养殖品种id
          reason: "", // 损失原因
          storageWeight: "", // 损失类型：1排塘损失、2塘口损失、3区域损失
          startDate: "",
          endDate: "",
          year: null,
          type: "",
        },
      },
      exportParams: {
        params: {},
      },
      lossTypeList: [
        { id: "1", value: "排塘损失" },
        { id: "2", value: "塘口损失" },
        { id: "3", value: "区域损失" },
        { id: "4", value: "排苗损失" },
      ],
      fileupload: "",
    };
  },
  computed: {},
  methods: {
    // 查询
    search() {
      this.params.currPage = 1;
      this.getPageList();
    },
    // 重置
    reset() {
      this.params.params.baseId = this.baseList[0].id;
      this.params.params.type = "";
      this.params.params.startDate = "";
      this.params.params.endDate = "";

      this.params.params.breedingAreaId = "";
      this.params.params.boxId = "";
      this.params.params.periodId = "";
      this.params.params.breedingCategoryId = "";
      this.params.params.breedNameId = "";
      this.params.params.reason = "";
      this.params.params.storageWeight = "";
      this.changeTime("Y");
      this.params.params.year = localStorage.getItem("m-year") ? localStorage.getItem("m-year") : String(new Date().getFullYear());
      this.params.currPage = 1;
      this.params.pageSize = 13;
      this.getPageList();
    },
    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.baseName === "合计") {
        return "heji-row";
      }
    },
    // 选择月
    monthChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val[0];
      this.params.params.endDate = val[1];
    },
    // 选择日期
    dateChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val[0];
      this.params.params.endDate = val[1];
    },
    handleSizeChange(event) {
      this.params.currPage = 1;
      this.params.pageSize = event;
      this.getPageList(this.params);
    },
    handleCurrentChange(event) {
      this.params.currPage = event;
      this.getPageList(this.params);
    },
    // 分页
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getListByPages(this.params).then((data) => {
        if (data.code == "0000") {
          this.pageNo = data.data.pageNumber;
          this.pageSize = data.data.pageSize;
          this.totalCount = data.data.totalCount;
          this.pagelist = data.data;
          this.lossDataList = this.pagelist.list;
          // 导出的参数 解决选择了查询条件但没有点击查询时导出数据不一致的bug
          this.exportParams = JSON.parse(JSON.stringify(this.params));
        }
        loading.close();
      });
    },
    // 导出
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        const params = {
          titleName: "损失数据查询列表",
          sheetName: "列表",
          fileName: "损失数据查询列表",
          param: this.params,
        };
        Page.exportDatas(exportTable(), params);
      });
    },
    // 模板下载
    download() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        const params = {
          fileName: "损失数据信息模板导入",
        };
        Page.exportDatas(downloadTemplate(), params);
      });
    },
    /**
     * 根据时间段查询数据
     * @param time
     */
    changeTime(time) {
      this.params.params.type = time;
      if (time === "D" || time === "M") {
        // 当前选择具体日期
        this.params.params.year = null;
      } else {
        if (time === "Y") {
          // 当前选择月份 / 年份
          this.params.params.startDate = "";
          this.params.params.endDate = "";
          this.monthRange = [];
          this.dateRange = [];
        }
      }
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  components: { MyPagination, FileUpload },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
    Page.pagesTableFixed(); // 表头固定
  },
  created() {
    this.tableHeight = window.innerHeight - 500;
    this.params.params.orgId = localStorage.getItem("orgId");
    // this.params.params.orgId = "7a5cfc1b-1cbe-445a-915a-d31cc9c9649e";
    this.orgName = localStorage.getItem("orgName");
    this.fileupload = importTable();
    this.changeTime("Y");
    this.params.params.year = localStorage.getItem("m-year") ? localStorage.getItem("m-year") : String(new Date().getFullYear());
    getBatchList(this.params.params.orgId).then((data) => {
      if (data.code === "0000") {
        this.periodList = data.data;
      }
    });
    getOrgInfoByOrgId(this.params.params.orgId).then((data) => {
      if (data.code === "0000") {
        const topParentId = data.data.id;
        getBreedList(topParentId).then((data) => {
          if (data.code === "0000") {
            this.breedList = data.data;
          }
        });
      }
    });
    getDictionaryByType("lossOfDetails").then((data) => {
      if (data.code === "0000") {
        this.lossCauseList = data.data;
      }
    });
    setTimeout(async () => {
      // 养殖场
      const base = await new Promise((resolve, reject) => {
        getBaseListsByUser().then((res) => {
          resolve(res);
        });
      });
      if (base && base.code == "0000") {
        this.baseList = base.data;
        this.params.params.baseId = this.baseList[0].id;

        // 查询分页
        this.getPageList();
      }
    }, 0);
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
    "params.params.baseId"(val) {
      this.breedTypeList = [];
      this.groupList = [];
      this.params.params.breedingCategoryId = "";
      this.params.params.breedingAreaId = "";
      if (!val) {
        return;
      }
      queryBaseGroupList(val).then((res) => {
        if (res.code == "0000") {
          this.groupList = res.data;
        }
      });
      getBreedTypeList(val).then((data) => {
        if (data.code === "0000") {
          this.breedTypeList = data.data;
        }
      });
    },
    "params.params.breedingAreaId"(val) {
      this.params.params.boxId = "";
      this.boxList = [];
      if (!val) {
        return;
      }
      listDataPermissionBoxData(val).then((res) => {
        if (res.code == "0000") {
          this.boxList = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped></style>